

/**
 * NMS Carousel Scroll Progress Component
 */
   class NMSCarouselScrollProgress extends window.NMSBaseClass {
  constructor(element) {
    super();

    this.element = element;
    this.progressId = element.dataset.progressId;

    this.carousel = null;
    this.progressBar = null;

    this.onScroll = null;
    this.onChange = null;
    this.onSettle = null;
    this.onResize = null;

    window.neemans = window.neemans || {};
    window.neemans.carouselScrollProgress = window.neemans.carouselScrollProgress || {};
    window.neemans.carouselScrollProgress[this.progressId] = this;
  }

  init() {
    super.init();
    this.setupScrollProgress();
    this.bindEvents();
  }

  setupScrollProgress() {
    this.carousel = this.element.querySelector('scroll-carousel');
    this.progressBar = this.element.querySelector('[data-ref="progress-bar"]');

    if (!this.carousel || !this.progressBar) return;

    this.updateProgress();
  }

  bindEvents() {
    if (!this.carousel || !this.progressBar) return;

    this.onScroll = this.debounce(this.updateProgress.bind(this), 16);
    this.onChange = this.updateProgress.bind(this);
    this.onSettle = this.updateProgress.bind(this);
    this.onResize = this.debounce(this.updateProgress.bind(this), 250);

    this.carousel.addEventListener('scroll', this.onScroll, { passive: true });
    this.carousel.addEventListener('carousel:change', this.onChange);
    this.carousel.addEventListener('carousel:settle', this.onSettle);
    window.addEventListener('resize', this.onResize);
  }

  updateProgress() {
    if (!this.carousel || !this.progressBar) return;

    const scrollLeft = this.carousel.scrollLeft || 0;
    const totalWidth = this.carousel.scrollWidth || 0;
    const carouselWidth = this.carousel.clientWidth || 0;

    if (!totalWidth || !carouselWidth) return;

    const scrollWidth = totalWidth - carouselWidth;
    const baseProgress = (carouselWidth / totalWidth) * 100;
    const remainingProgress = 100 - baseProgress;
    const scrollProgress = scrollWidth > 0 ? (scrollLeft / scrollWidth) * remainingProgress : 0;
    const finalProgress = Math.min(Math.max(baseProgress + scrollProgress, baseProgress), 100);

    this.progressBar.style.width = finalProgress + '%';

    if (typeof this.dispatchNMSEvent === 'function') {
      this.dispatchNMSEvent('progress-update', {
        progress: finalProgress,
        baseProgress,
        scrollProgress,
        scrollLeft,
        scrollWidth
      });
    }
  }

  getCurrentProgress() {
    if (!this.carousel) return 0;

    const scrollLeft = this.carousel.scrollLeft || 0;
    const totalWidth = this.carousel.scrollWidth || 0;
    const carouselWidth = this.carousel.clientWidth || 0;

    if (!totalWidth || !carouselWidth) return 0;

    const scrollWidth = totalWidth - carouselWidth;
    const baseProgress = (carouselWidth / totalWidth) * 100;
    const remainingProgress = 100 - baseProgress;
    const scrollProgress = scrollWidth > 0 ? (scrollLeft / scrollWidth) * remainingProgress : 0;

    return Math.min(Math.max(baseProgress + scrollProgress, baseProgress), 100);
  }

  destroy() {
    if (this.carousel) {
      if (this.onScroll) this.carousel.removeEventListener('scroll', this.onScroll);
      if (this.onChange) this.carousel.removeEventListener('carousel:change', this.onChange);
      if (this.onSettle) this.carousel.removeEventListener('carousel:settle', this.onSettle);
    }

    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }

    if (window.neemans?.carouselScrollProgress?.[this.progressId]) {
      delete window.neemans.carouselScrollProgress[this.progressId];
    }

    super.destroy();
  }
}

function initNMSCarouselScrollProgress() {
  if (!window.NMSBaseClass) return;

  const elements = document.querySelectorAll('[data-nms-carousel-scroll-progress]');

  elements.forEach((element) => {
    if (element.dataset.initialized === 'true') return;

    const instance = new NMSCarouselScrollProgress(element);
    instance.init();

    element.dataset.initialized = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNMSCarouselScrollProgress);
} else {
  initNMSCarouselScrollProgress();
}

// Homepage tab swaps (nms-homepage-tabs.js) insert fresh carousels via innerHTML
document.addEventListener('nms:content-updated', initNMSCarouselScrollProgress);

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initNMSCarouselScrollProgress);
}

